import React, { useMemo, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Box, Typography, Chip } from '@mui/material';

const MERGE_TAGS = [
  { label: 'First Name', value: '{{first_name}}' },
  { label: 'Last Name', value: '{{last_name}}' },
  { label: 'Email', value: '{{email}}' },
];

const EmailEditor = ({ value, onChange, minHeight = 220 }) => {
  const quillRef = useRef(null);

  const modules = useMemo(() => ({
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: [] }],
      ['link'],
      ['clean'],
    ],
  }), []);

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'align',
    'link',
  ];

  const insertMergeTag = (tag) => {
    const editor = quillRef.current?.getEditor();
    if (!editor) {
      onChange(`${value || ''}${tag}`);
      return;
    }

    const range = editor.getSelection(true);
    const index = range ? range.index : editor.getLength();
    editor.insertText(index, tag);
    editor.setSelection(index + tag.length);
  };

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        Email Content
      </Typography>

      <Box sx={{ mb: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {MERGE_TAGS.map((tag) => (
          <Chip
            key={tag.value}
            label={tag.label}
            size="small"
            variant="outlined"
            onClick={() => insertMergeTag(tag.value)}
            sx={{ cursor: 'pointer' }}
          />
        ))}
      </Box>

      <Box
        sx={{
          '& .ql-container': { minHeight },
          '& .ql-editor': { minHeight },
          '& .ql-toolbar': {
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
            bgcolor: 'grey.50',
          },
          '& .ql-container.ql-snow': {
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: 4,
            bgcolor: 'background.paper',
          },
        }}
      >
        <ReactQuill
          ref={quillRef}
          theme="snow"
          value={value || ''}
          onChange={onChange}
          modules={modules}
          formats={formats}
          placeholder="Write your email message here..."
        />
      </Box>

      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
        Use merge tags to personalize each email (e.g. Hello {'{{first_name}}'}).
      </Typography>
    </Box>
  );
};

export default EmailEditor;
